import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getStoredAuth } from '../api/client';

const ProtectedRoute: React.FC = () => {
  const { token } = getStoredAuth();

  if (!token) {
    return <Navigate to="/member/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
